// src/components/PlayerProgress.jsx
import React from "react";
import "./PlayerProgress.css";

function PlayerProgress({ progreso, temas, temasCompletados }) {
  return (
    <div className="playerprogress-panel">

      {/* Texto de instrucciones arriba del progreso */}
      <p className="texto-instruccion">
        Responde <b>4 preguntas</b> de cada tema para completarlo.<br />
        ¡Sé el primero en completar <b>10 temas</b> para ganar la partida!
      </p>

      {/* Progreso de cada tema */}
      {temas.map((tema, i) => (
        <div
          key={tema}
          className={`progreso-row ${temasCompletados?.includes(tema) ? "tema-completado" : ""}`}
        >
          <span className="tema-label">{tema}</span>
          <div className="niveles-bar">
            {[1, 2, 3, 4].map(n => (
              <span
                key={n}
                className={`nivel-dot ${progreso?.[tema] >= n ? "acertado" : ""}`}
              ></span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default PlayerProgress;
